import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { CHANGE_TAB } from "../../constants/actionTypes";
import { profileUpdateService } from "../../Network/services/profileUpdateService";
import { useLocation, useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import Files from "react-files";
import { LoadingOverlay, Loader } from "react-overlay-loader";
import { ToastContainer, toast } from "react-toastify";
import TagsInput from "react-tagsinput";
import DatePicker from "react-datepicker";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import "react-tagsinput/react-tagsinput.css";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-dropdown-select";
import "./MyResumeEditView.css";
import FilePreview from "../FilePreview";

const mapStateToProps = (state) => ({
  ...state.articleList,
});

const mapDispatchToProps = (dispatch) => ({
  onTabClick: (tab, pager, payload) =>
    dispatch({ type: CHANGE_TAB, tab, pager, payload }),
});

const MyResumeEditView = (props) => {
  let location = useLocation();
  let history = useHistory();

  
  const [loading, setLoading] = useState(false);
  const { isOpen, setIsOpen } = useState(false);
  const [name, setName] = useState("");
  const [certificate, setCertificate] = useState([]);
  const [resume, setResume] = useState();

  const [certlist, setCertlist] = useState();
  const [resumelist, setResumelist] = useState();
  const [existingCertificates, setExistingCertificates] = useState([]);

  useEffect(() => {
    
    let user = JSON.parse(window.localStorage.getItem("UserData"));
    setName(user.first_name + " " + user.last_name);
    setCertificate(
      user.certificates == ""
        ? []
        : []
    );
    setResume(
      user.resume == ""
        ? ""
        : user.resume
    );
   
    let resumeFile = "";
    if(user.resume!==""){
      let resumeFilename = user.resume.split('/').pop();
      let resumeExt = resumeFilename.split('.').pop();

      resumeFile = (    
        <FilePreview 
          fileUrl={user.resume}
          fileName={resumeFilename}
          onRemove={null}
        />
      )

    }
    setResumelist(resumeFile);

    let certificates = "";
    let existingCerts = [];
    if(user.certificates!==""){


      existingCerts = user.certificates.split(',');
    certificates = existingCerts.map((item, index) => {
        let filename = item.split('/').pop();
        
        return (    
          <FilePreview 
            key={index}
            fileUrl={item}
            fileName={filename}
            onRemove={() => handleCertificateRemoveItem({ target: { getAttribute: (attr) => attr === 'name' ? item : null } })}
          />
        )
      })
    } 
    setExistingCertificates(existingCerts);
    setCertlist (certificates);


  }, []);

  let back = (e) => {
    e.preventDefault();
    history.goBack();
  };

  const profileupdate = (e) => {
    e.preventDefault();
    setLoading(true);
      

    const form = new FormData();
    // Append multiple certificate files
    certificate.forEach(file => {
      form.append('certificates[]', file);
    });
    form.append('resume', resume);

    profileUpdateService
      .profileUpdatecall(form)
      .then(async (res) => {
        if (res.status == 200) {
          window.localStorage.setItem("UserData", JSON.stringify(res.data[0]));
          window.localStorage.setItem("auth_token", res.data[0].auth_token);
          toast.success(res.message, {
            position: "top-right",
            type: "success",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
          history.goBack();
        } else {
          toast.success(res.message, {
            position: "top-right",
            type: "error",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
        }
      })
      .catch((err) => {
        toast.success("Something went wrong! please try again later!!", {
          position: "top-right",
          type: "error",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const redirect = () => {
    history.push("/myresumeEdit");
  };

  function certificateChange(event) {
    const files = Array.from(event.target.files);
    
    const totalCertificates = existingCertificates.length + files.length;
    
    if (totalCertificates > 5) {
      const remainingSlots = 5 - existingCertificates.length;
      toast.error(`Maximum 5 certificates allowed. You can upload up to ${remainingSlots} more certificate(s).`, {
        position: "top-right",
        type: "error",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
      });
      event.target.value = '';
      return;
    }
    
    const oversizedFiles = files.filter(file => file.size > 10 * 1024 * 1024);
    
    if (oversizedFiles.length > 0) {
      toast.error(`Certificate file(s) size should not exceed 10MB. ${oversizedFiles.length} file(s) are too large.`, {
        position: "top-right",
        type: "error",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
      });
      // Clear the input
      event.target.value = '';
      return;
    }
    
    setCertificate(files);
  }

  function resumeChange(e) {
    const file = e.target.files[0];
    
    if (file) {
      setResume(file);
    }
  }

  
  //remove certificates and resume
  const handleCertificateRemoveItem = (e) => {
    const certName = e.target.getAttribute("name")
    setLoading(true);
      

    const form = new FormData();   
    form.append('certificate', certName);

    profileUpdateService
      .removeCertificate(form)
      .then(async (res) => {
        if (res.status == 200) {
          window.localStorage.setItem("UserData", JSON.stringify(res.data[0]));
          window.localStorage.setItem("auth_token", res.data[0].auth_token);
          toast.success(res.message, {
            position: "top-right",
            type: "success",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
          window.location.reload(false);
        } else {
          toast.success(res.message, {
            position: "top-right",
            type: "error",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
        }
      })
      .catch((err) => {
        toast.success("Something went wrong! please try again later!!", {
          position: "top-right",
          type: "error",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });
      })
      .finally(() => {
        setLoading(false);
      });

   };

  return (
    <LoadingOverlay>
      <section className="explore explore1">
      <div className="container">
        <div className="banner">
          <div className="row">
            <div className="col-md-4">
              <div className="breadcrumps">
                <ul>
                  <li>
                    <a href="#!" onClick={(e) => back(e)}>
                      <i className="bx bx-chevron-left" /> Back to Profile
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <section className="onbord-section">
          <div className="row">
            <div className="col-md-12 text-center">
            <h1 className="title">{name}, tell us a bit more about yourself</h1>
            <p className="subtitle">GigFWS needs the below information to help you better.</p>
            </div>
          </div>
          <div className="row">
				<div className="col-md-12">
					
					<div className="board-box board-box2 post-new-job">

						<form>
              <div className="wrapper" style={{textAlign: "center"}}>
                  <div className="form-group myresume-form-section">
                      <label className="myresume-form-label">Certificates Upload (Optional)</label>
                      <div className="myresume-file-input-wrapper">
                        <input 
                          type="file" 
                          className="custom-file-input myresume-file-input" 
                          onChange={certificateChange} 
                          style={{border: 'none', width: '100%', textAlign: 'center'}}
                          multiple 
                        />
                      </div>
                      </div>
                      {certlist && <div className="form-group myresume-file-preview-container">
                        {certlist}
                      </div>}
                  <div className="form-group myresume-form-section-duplicate">
                      <label className="myresume-form-label">Resume Upload (Optional)</label>
                      <div className="myresume-file-input-wrapper">
                        <input 
                          type="file" 
                          className="custom-file-input myresume-file-input" 
                          onChange={resumeChange} 
                          style={{border: 'none', width: '100%', textAlign: 'center'}}
                        />
                      </div>
                      </div>
                      {resumelist && <div className="form-group myresume-file-preview-container">
                        {resumelist}
                      </div>}
                  <div className="col-md-12 myresume-submit-section">
                  <button onClick={profileupdate} className="btn btn-default">SUBMIT</button>
                  </div>
              </div>

				        </form>

					</div>

				</div>
			</div>
        </section>
      </div>
    </section>
    <Loader loading={loading} />
    </LoadingOverlay>
    
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(MyResumeEditView);
